const AuthTeamComponent = () => import('@/views/AuthTeam/AuthTeamView')

export default [
    {
        path:'/AuthTeamIndex',
        name:'AuthTeamRouter',
        component:AuthTeamComponent
    }
]